import React from 'react';
import { Theme, makeStyles, Link } from '@material-ui/core';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { StyledText } from './StyledText';


const useStyles = makeStyles<Theme>((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  linkText: {
    fontSize: '18px',
    fontWeight: 500,
    marginLeft: '10px',
    color: '#0077B5',
    flexWrap: 'nowrap'
  },
  placeholderText: {
    color: theme.palette.text.primary,
    marginLeft: '10px'
  },
  textWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap'
  }
}));

interface LinkedInLinkProps {
  linkedIn: string,
  marginBottom?: string,
  marginTop?: string,
  marginLeft?: string,
  marginRight?: string,
  placeholderMode?: boolean
}

const LinkedInLink: React.FC<LinkedInLinkProps> = ({
  linkedIn,
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
  placeholderMode = false
}) => {
  const styles = useStyles();
  return (
    <div
      style={{ marginTop, marginLeft, marginBottom, marginRight }}
      className={styles.root}
    >
      <LinkedInIcon style={{ color: '#0077B5' }} />
      {
      placeholderMode ? <StyledText variant='body1' className={styles.placeholderText}>{linkedIn}</StyledText>
        : (
          <Link underline='none' href={linkedIn} target='_blank' display='inline'>
            <div className={styles.textWrapper}>
              <StyledText className={styles.linkText}>LinkedIn profile</StyledText>
              <KeyboardArrowRightIcon fontSize='small' style={{ color: '#0077B5' }} />
            </div>
          </Link>
        )
    }
    </div>
  );
};

export default LinkedInLink;
